const messages = {
  zh: {
    common: {
      loading: '加载中...',
    },
    home: {
      text: '首页',
      title: '中港智能',
      title1: '',
      subheading: '生为探索,持续创新',
      title2: '团队成员',
      title3: '合作伙伴',
      content: '​​',
      content1: '中港智能装备有限公司（以下简称"中港智能"）成立于2024年，总部位于深圳宝安，在西安、北京、济南设有研发中心和办公点。中港智能专注于高端智能行业无人机研发生产制造，聚焦安防行业应用，拥有全球领先的侦察无人机抗干扰技术（无GNSS飞行-视觉定位导航和数据链抗干扰）、AI识别技术、感知避障技术、高清影像技术，面向海外无人机品牌商与方案商，提供全球有竞争力的无人机全栈技术解决方案：包括三轴高清吊舱模组、AI识别制导模组、无GNSS飞行（视觉定位与导航系统）模组、抗干扰数据链模组以及高端行业无人机整机ODM和无人机本土化智造（生产和组装）解决方案。以全球领先技术为支撑，打造智慧高效、高性价比的无人机安防一体化解决方案，致力于成为全球高端安防行业无人机领航者。',
    },
    products: {
        text: '产品',
        title: '产品中心',
        intro: '产品介绍',
        subtitle: '行业级飞行平台及生态产品',
        product_1: 'SIE抗干扰信号放大器',
        product_1_desc: '全频段自适应(800MHz-6GHz) | 极强抗干扰性能 | 适配Autel全系列产品 | 10W大功率输出 | IP68级防水 | 自适应跳频',
        product_2: 'SIE S3T',
        product_2_desc: '全新三主摄云台相机系统 | 超强抗干扰 | 640*480 19mm热感红外镜头 | CarbonLink 20千米超远图传 | 智能飞行 | 47分钟续航 | AI超级夜景',
        product_2_title: 'SIE S3T',
        product_2_subtitle: '三摄联动，掌控全局',
        product_3: 'SIE 智能遥控器',
        product_3_desc: '15km图传距离 | 1000nits亮度 | 4小时续航 | 128G存储空间 | 定制化系统 | 多口输出',
        product_4: 'SIE 小型抗干扰数据链模组',
        product_4_desc: '超强抗干扰 | 20KM传输距离 | 小尺寸轻重量 | 800MHz~6GHz全频覆盖 | 多频自适应跳频 | 支持扩展10W信号放大器',
        product_5: 'SIE FPV智能识别跟踪AI模组',
        product_5_desc: '多光融合 | AI精准识别 | 目标识别 | 种类丰富 | 末端制导',
        product_6: 'SIE 小型高端行业多光吊舱',
        product_6_desc: '重量仅200g | 10X光学变焦 | 160倍混合变焦 | 1.2KM激光测距 | 业界领先的影像技术',
        product_7: 'EVO Max 4T',
        product_7_desc: '720°全向避障 | 超强抗干扰 | A-Mesh组网 | 10倍光学变焦 | 15千米图传距离 | 42分钟续航',
        product_7_title: 'EVO Max 4T',
        product_7_subtitle: '行业应用新旗舰',
        product_8: 'EVO Max 4N',
        product_8_desc: '720°全向避障 | 超强抗干扰 | A-Mesh组网 | 超星光级夜视 | 5公里光源体侦查 | 42分钟续航',
        product_9: 'EVO Lite 640T 智能遥控器V3',
        product_9_desc: '智能遥控器V3 | 轻小便携 | AI识别和定位 | 三向视觉避障 | 6K分辨率 | 640*512红外热成像 | 40分钟续航',
        product_9_title: 'EVO Lite 640T',
        product_9_subtitle: '轻装上阵 小而不凡',
        product_10: 'EVO Lite 640T 智能遥控器SE V2',
        product_10_desc: '智能遥控器SE V2 | 轻小便携 | AI识别和定位 | 三向视觉避障 | 6K分辨率 | 640*512红外热成像 | 40分钟续航',
        product_11: 'X8T V640 标准遥控器',
        product_11_desc: '滑道式标准遥控器 | 全新三主摄云台相机系统| 640*480 19mm热感红外镜头| RokLink 5.0 20Km图传| Al超级夜景',
        product_12: 'X8T V640 TX20遥控器',
        product_12_desc: 'TX20带屏遥控器 | 全新三主摄云台相机系统| 640*480 19mm热感红外镜头| RokLink 5.0 20Km图传| Al超级夜景',
        product_13: 'X8 Tele Max TX20遥控器',
        product_13_desc: 'TX20带屏遥控器 | 广角长焦双主摄30X混合变焦 | 4K/60fps视频 | RokLink 5.0 20Km图传 | Al超级夜景',
        product_13_title: 'X8 Tele Max',
        product_13_subtitle: '双摄随行, 见所未见',
        product_14: 'X8 Tele Max 标准遥控器',
        product_14_desc: '滑道式标准遥控器 | 广角长焦双主摄30X混合变焦 | 4K/60fps视频 | RokLink 5.0 20Km图传 | Al超级夜景',
        gallery: {
          all: '全部',
          enterprise_products: '企业产品',
          hardware: '硬件设备',
        },
        contact_business: '请联系我们了解该产品详情',
      },
    solution: {
      text: '解决方案',
      title: '解决方案中心',
      subtitle: '为千行百业提效赋能',
      content: '无人机解决方案通过融合"​​高空视角+AI分析+全自动作业​​", 重构安防、巡检与测绘的操作范式。​安防领域​​: 构建立体防控体系,通过指挥中心快速掌握现场状况，解决安防压力大、巡逻效率低、难以取证的难题。​巡检领域​​: 全流程自动化替代高危人力, 实现全方位、立体式的自主智能巡检。​测绘领域​​: 多旋翼无人机可进行空间数据照片采集,基于其机械快门、高像素相机以及免像控的特性,配合建模软件自动生成2D和3D模型,可以及时高效地获取区域空间布局。',
      point1: '安防',
      point2: '巡检',
      point3: '测绘',
    },
    about: {
      text: '关于我们',
    },
    news: {
      text: '新闻',
    },
    contact: {
      text: '联系我们',
      title: '联系我们',
      title1: '加入我们',
      title2: '请联系我们',
      content1: '如果您有更多想要了解的信息，或想与我们进行合作交流，请通过WhatsApp或Telegram联系我们。',
    },
    city: {
      beijing: '北京',
      shanghai: '上海',
      hongkong: '香港',
      puchong: '蒲种',
      baltimore: '巴尔的摩',
      newyork: '纽约',
      newhaven: '纽黑文',
      amsterdam: '阿姆斯特丹',
      krakow: '克拉科夫',
      stockholm: '斯德哥尔摩',
      london: '伦敦',
      york: '约克',
      cambridge: '剑桥',
    },
  },
  en: {
    common: {
      loading: 'Loading...',
    },
    home: {
      text: 'HOME',
      title: 'SINO INTELLIGENT EQUIPMENT',
      subheading: 'Born to Explore, Continuously Innovate',
      title1: 'UNIFY FOR CHANGE',
      title2: 'THE TEAM MEMBERS',
      title3: 'OUR PARTNER',
      content: '',
      content1: 'SINO INTELLIGENT EQUIPMENT (hereinafter referred to as "SIE") was founded in 2024, with its headquarters in Bao\'an, Shenzhen, and R&D centers and offices in Xi\'an, Beijing, and Jinan. SIE focuses on the R&D, production, and manufacturing of high-end intelligent industrial UAVs, with applications centered on the security industry. The company possesses world-leading anti-jamming technologies for reconnaissance drones (GNSS-denied flight—vision-based positioning and navigation, and anti-jamming data links), AI recognition, perception and obstacle avoidance, and high-definition imaging. Targeting overseas UAV brands and solution providers, it delivers globally competitive full-stack UAV technology solutions, including three-axis HD gimbal modules, AI recognition and guidance modules, GNSS-denied flight (vision positioning and navigation system) modules, anti-jamming data link modules, as well as ODM services for high-end industrial UAVs and localized intelligent manufacturing (production and assembly) solutions. Backed by world-leading technologies, the company builds smart, efficient, and cost-effective integrated UAV security solutions and is committed to becoming a global leader in high-end security UAVs.',
    },
    products: {
        text: 'PRODUCTS',
        title: 'Product Center',
        intro: 'Product Introduction',
        subtitle: 'Industry-level Flying Platform and Ecological Products',
        product_1: 'SIE Anti-Interference Signal Booster',
        product_1_desc: 'Full-band Adaptive (800MHz-6GHz) | Strong Anti-Interference Performance | Compatible with Autel Full Series Products | Max 10W Power Output | IP68 Waterproof | Adaptive Frequency Hopping',
        product_2: 'SIE S3T',
        product_2_desc: 'Brand-new Triple-camera Gimbal System | Strong Anti-Interference | 640*480 19mm Thermal Infrared Lens | CarbonLink 20km Video Transmission | Intelligent Flight Modes | 47 Minutes Flight Time | AI Super Night Video',
        product_2_title: 'SIE S3T',
        product_2_subtitle: 'Triple-camera synergy, Capturing the whole perspective',
        product_3: 'SIE Smart Controller',
        product_3_desc: '9.3 Miles Transmission Range | 1000nit Max. Brightness | 4 Hours Battery Life | 128GB Internal Storage',
        product_4: 'SIE CarbonLink',
        product_4_desc: 'Strong Anti-Interference | 20KM Transmission Range | Compact and Lightweight | 800MHz~6GHz Full-band Coverage | Multi-frequency Adaptive Hopping | Supports 10W Signal Booster Expansion',
        product_5: 'SIE SmartCube',
        product_5_desc: 'Multi-spectral Fusion | AI Precision Recognition | Target Identification | Rich Varieties | Terminal Guidance',
        product_6: 'SIE SmartPod',
        product_6_desc: 'Weighs Only 200g | 10X Optical Zoom | 160X Hybrid Zoom | 1.2KM Laser Rangefinder | Industry-leading Imaging Technology',
        product_7: 'EVO Max 4T',
        product_7_desc: 'A-Mesh Network | 720° Obstacle Avoidance | 42 min Flight Time | Autonomous Flight',
        product_7_title: 'EVO Max 4T',
        product_7_subtitle: 'Reach New Frontiers',
        product_8: 'EVO Max 4N',
        product_8_desc: 'Starlight Vision Camera | No Blind Spots | 42 min Flight Time | Autonomous Flight',
        product_9: 'EVO Lite 640T Smart Remote Controller V3',
        product_9_desc: 'Smart Remote Controller V3 | Lightweight and Portable | 40 Mins Flight Time | 6K Resolution | 640*512 Infrared Thermal Imaging',
        product_9_title: 'EVO Lite 640T',
        product_9_subtitle: 'Lightweight Yet Mighty',
        product_10: 'EVO Lite 640T Smart Controller SE V2',
        product_10_desc: 'Smart Controller SE V2 | Lightweight and Portable | 40 Mins Flight Time | 6K Resolution | 640*512 Infrared Thermal Imaging',
        product_11: 'X8T V640 Standard Remote Controller',
        product_11_desc: 'Standard Remote Controller | Brand-new Triple-camera gimbal system | 640*480 19mm Thermal Infrared Lens | RokLink 5.0 20Km Video Transmission | Al Super Night Video',
        product_12: 'X8T V640 TX20 Remote Controller',
        product_12_desc: 'TX20 Remote Controller | Brand-new Triple-camera gimbal system | 640*480 19mm Thermal Infrared Lens | RokLink 5.0 20Km Video Transmission | Al Super Night Video',
        product_13: 'X8Tele Max TX20 Remote Controller',
        product_13_desc: 'TX20 Remote Controller | Wide-Angle and Tele Camera, 30X Hybrid Zoom | 4K/60fps Video RokLink 5.0 20Km Video Transmission | Al Super Night Video',
        product_13_title: 'X8 Tele Max',
        product_13_subtitle: 'Beyond Vision, See the Unseen',
        product_14: 'X8 Tele Max Standard Remote Controller',
        product_14_desc: 'Standard Remote Controller | Wide-Angle and Tele Camera, 30X Hybrid Zoom | 4K/60fps Video RokLink 5.0 20Km Video Transmission | Al Super Night Video',
        gallery: {
          all: 'All',
          enterprise_products: 'Drones',
          hardware: 'Accessories',
        },
        contact_business: 'Please contact us for more product details',
      },
    solution: {
      text: 'SOLUTION',
      title: 'Solution Center',
      subtitle: 'Autonomous, Intelligent, Digital Industry Solutions',
      content: 'Drone solutions integrate "aerial perspective + AI analytics + autonomous operation" to redefine operational paradigms in security, inspection, and surveying: Security Field: Establishes a three-dimensional security system, enabling command centers to rapidly assess situations and address critical challenges including high security pressure, low patrol efficiency, and evidence collection difficulties. Inspection Field: Achieves full-process automation to replace high-risk manual labor, delivering comprehensive, multi-dimensional intelligent inspections. Surveying Field: Utilizes multi-rotor drones for spatial data capture. Equipped with mechanical shutters, high-pixel cameras, and ground control point-free technology, they collaborate with modeling software to auto-generate 2D/3D models, enabling rapid acquisition of regional spatial layouts',
      point1: 'Security',
      point2: 'Inspection',
      point3: 'Surveying And Mapping',
    },
    about: {
      text: 'ABOUT US',
    },
    news: {
      text: 'NEWS',
    },
    contact: {
      text: 'CONTACT',
      title: 'CONTACT US',
      title1: 'JOIN US',
      title2: 'KEEP IN TOUCH WITH US',
      content1: 'If you want to know more information, or to cooperate with us, please contact us through WhatsApp or Telegram.',
      content2: 'Zero Carbon Plus Technology is committed to building a world-leading platform for climate information exchange, knowledge sharing and tailored consultation services. Our founders come from the world top universities and leading high-tech companies. Please join in us to make a difference in the upgrading and development of enterprises under the background of China 2030 emission peak and 2060 carbon neutrality targets.',
      content3: 'Resume delivery: Send your resume to',
    },
    city: {
      beijing: 'Beijing',
      shanghai: 'Shanghai',
      hongkong: 'Hong Kong',
      puchong: 'Puchong',
      baltimore: 'Baltimore',
      newyork: 'New York',
      newhaven: 'New Haven',
      amsterdam: 'Amsterdam',
      krakow: 'Krakow',
      stockholm: 'Stockholm',
      london: 'London',
      york: 'York',
      cambridge: 'Cambridge',
    },
  },
}

export default messages
